export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-mail-send-line"></i>
            联系
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">联系我们</h2>
          <p className="text-foreground-600 text-sm md:text-base mb-8 leading-relaxed">
            有漫画推荐、版权合作或任何建议？欢迎通过以下方式联系我们。香蕉动漫期待与每一位热爱漫画的创作者和读者交流。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#contact"
              onClick={(e) => e.preventDefault()}
              className="inline-flex items-center gap-2 px-5 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-mail-line"></i>
              投稿与合作
            </a>
            <a
              href="#contact"
              onClick={(e) => e.preventDefault()}
              className="inline-flex items-center gap-2 px-5 py-3 bg-background-50 hover:bg-background-200 text-foreground-700 font-medium rounded-lg border border-background-300/60 transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              <i className="ri-question-answer-line"></i>
              意见反馈
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}